import {action, observable, runInAction} from 'mobx'
import {PaginationProps} from "antd/lib/pagination";
import {Pagination} from "../../../constants/common/Pagination";
import {CouponTabsApi, CouponTabsGetListRequest, CouponTabsGetListResponse} from "../../../swagger";
import {adminApiWrapper} from "../../../common/Api/Admin/adminApiWrapper";
import {CouponTabsGetListRowForm} from "../../../swagger/api";
import {createApiConfiguration} from "../../../utils/apiFactory";

export class CouponTabsStore {
  @observable
  public loading: boolean = false;

  @observable.ref
  public list: CouponTabsGetListRowForm[] = [];

  public pagination: PaginationProps = Pagination.defaultProps;
  public request: CouponTabsGetListRequest = new CouponTabsGetListRequest();

  @action
  getList() {
    let api = new CouponTabsApi(createApiConfiguration());
    this.request.pagination = {current: this.pagination.current!, pageSize: this.pagination.pageSize!};

    this.loading = true;
    return adminApiWrapper(() => {
        return api.getList(this.request).then((res: CouponTabsGetListResponse) => {
          runInAction(() => {
            this.list = res.list!;
            this.pagination.total = res.total;
            this.loading = false;
          })
        });
      },
      "CouponTabsGetList"
    );
  }
}


